<template>
  <TheMenuLayout>
    <BaseSectionHeader class="mb-2">
      {{$t('Invoices')}}
    </BaseSectionHeader>
    <BaseButton
      @click="downloadInvoice()"
      color="primary"
      outlined
      icon="mdi-file-pdf"
      class="mb-8"
    >
      {{$t('Download my summary')}}
    </BaseButton>
    <BaseSectionHeader>
      {{$t('Summary title')}}
    </BaseSectionHeader>
    <v-row class="mb-6">
      <v-col>
        <BaseNumberCard color="red lighten-3" :title="$t('Due amount')">
          {{ student.due_amount | currency }}
        </BaseNumberCard>
      </v-col>
      <v-col>
        <BaseNumberCard color="teal lighten-3" :title="$t('Paid')">
          {{ student.payments_amounts_sum | currency }}
        </BaseNumberCard>
      </v-col>
    </v-row>
    <BaseSectionHeader>
      {{ $t('Payments' )}}
    </BaseSectionHeader>
    <v-simple-table v-if="sortedPayments.length" class="mb-6">
      <thead>
        <tr>
          <th class="text-left">
            Montant
          </th>
          <th class="text-left">
            Méthode
          </th>
          <th class="text-left">
            Encaissé le
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(payment, index) in sortedPayments" :key="index">
          <td>
            {{ payment.amount | currency }}
          </td>
          <td>
            {{ payment.payment_method }}
          </td>
          <td>
            {{ payment.cashed_at | moment('L') }}
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <BaseParagraph class="info--text mb-6" v-else>
      Aucun paiement effectué
    </BaseParagraph>
    <BaseSectionHeader>
      Stages
    </BaseSectionHeader>
    <v-list class="mb-4">
      <template
        v-for="(registration, index) in registrations"
      >
        <v-divider :key="index" v-if="index != 0" />
        <v-list-item
          three-line
          :key="registration.id"
        >
          <v-list-item-content>
            <v-list-item-title>
              <strong>{{ registration.internship.name }}</strong>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ registration.internship.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="align-center align-self-stretch">
            <span><v-text v-if="registration.discount !== 0" class="mr-5">
              <i><s>{{ registration.internship.price | currency }}</s> -{{ registration.discount.toFixed(1) }}%</i>
            </v-text>
            <strong class="text-h6">{{ registration.price | currency }}</strong></span>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>

    <BaseSectionHeader>Payer par carte bancaire</BaseSectionHeader>
    <v-btn href="https://buy.stripe.com/5kA5lp5hceJjaw8aEE" block type="submit" color="primary">Ouvrir l'interface de paiement</v-btn>
  </TheMenuLayout>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { forEach } from 'lodash';
import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseNumberCard from '@/components/BaseNumberCard.vue';
import BaseParagraph from '@/components/BaseParagraph.vue';
import PaymentsApi from '@/backend/PaymentsApi';

export default {
  name: 'Invoices',
  components: {
    BaseSectionHeader,
    TheMenuLayout,
    BaseButton,
    BaseParagraph,
    BaseNumberCard,
  },
  created() {
    this.fetchMe();
    this.fetchPayments();
    this.fetchRegistrations();
  },
  data() {
    return {
      paymentAmount: undefined,
    };
  },
  methods: {
    ...mapActions('authentication', ['fetchMe']),
    ...mapActions(['fetchPayments', 'fetchRegistrations']),
    openPaymentPage() {
      PaymentsApi.create(this.paymentAmount).then((response) => {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = response.data.url;
        forEach(response.data, (value, key) => {
          if (key !== 'url') {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = value;

            form.appendChild(hiddenField);
          }
        });

        document.body.appendChild(form);
        form.submit();
      });
    },
    downloadInvoice() {
      this.axios({
        url: '/invoice',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Relevé de situation.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
  },
  computed: {
    ...mapState('authentication', ['student']),
    ...mapGetters(['sortedPayments']),
    ...mapState(['registrations']),
  },
};
</script>
